define(["exports", "@babel/runtime/helpers/esm/assertThisInitialized", "@babel/runtime/helpers/esm/inheritsLoose", "@babel/runtime/helpers/esm/defineProperty", "react", "styled-components", "react-onclickoutside", "react-intl-universal", "../../atoms", "../../utils"], function (_exports, _assertThisInitialized2, _inheritsLoose2, _defineProperty2, _react, _styledComponents, _reactOnclickoutside, _reactIntlUniversal, _atoms, _utils) {
  "use strict";

  var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;

  var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  _assertThisInitialized2 = _interopRequireDefault(_assertThisInitialized2);
  _inheritsLoose2 = _interopRequireDefault(_inheritsLoose2);
  _defineProperty2 = _interopRequireDefault(_defineProperty2);
  _react = _interopRequireWildcard(_react);
  _styledComponents = _interopRequireDefault(_styledComponents);
  _reactOnclickoutside = _interopRequireDefault(_reactOnclickoutside);
  _reactIntlUniversal = _interopRequireDefault(_reactIntlUniversal);

  var NavigationStyled = _styledComponents.default.nav.withConfig({
    displayName: "Navigation__NavigationStyled",
    componentId: "sc-xt302w-0"
  })(["width:100%;"]);

  var Navigation = /*#__PURE__*/function (_Component) {
    (0, _inheritsLoose2.default)(Navigation, _Component);

    function Navigation() {
      var _this;

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _Component.call.apply(_Component, [this].concat(args)) || this;
      (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
        opened: false
      });
      (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "toggleDropdown", function (e) {
        e.preventDefault();

        _this.setState(function (prevState) {
          return {
            opened: !prevState.opened
          };
        });
      });
      (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleClickOutside", function () {
        _this.setState({
          opened: false
        });
      });
      return _this;
    }

    var _proto = Navigation.prototype;

    _proto.render = function render() {
      var _this2 = this;

      var _this$props = this.props,
          menu = _this$props.menu,
          globalUrl = _this$props.globalUrl,
          hideHomeLink = _this$props.hideHomeLink;
      var opened = this.state.opened;
      return /*#__PURE__*/_react.default.createElement(NavigationStyled, {
        role: "navigation"
      }, /*#__PURE__*/_react.default.createElement(_atoms.NavList, null, !hideHomeLink && /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement(_atoms.NavigationLink, {
        title: _reactIntlUniversal.default.get('NAVEGACAO.HOME'),
        as: _atoms.GlobalLink,
        globalUrl: globalUrl,
        to: "/"
      }, _reactIntlUniversal.default.get('NAVEGACAO.HOME'))), menu.map(function (item) {
        var label = item.label;
        return /*#__PURE__*/_react.default.createElement("li", {
          key: "menu-" + label
        }, item.submenu ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_atoms.NavigationLink, {
          icon: "true",
          title: _reactIntlUniversal.default.get("NAVEGACAO." + (0, _utils.intlParse)(label)),
          as: _atoms.GlobalLink,
          to: "#",
          globalUrl: globalUrl,
          onClick: _this2.toggleDropdown,
          active: "" + opened
        }, _reactIntlUniversal.default.get("NAVEGACAO." + (0, _utils.intlParse)(label)), /*#__PURE__*/_react.default.createElement("box-icon", {
          name: "chevron-down"
        })), /*#__PURE__*/_react.default.createElement(_atoms.DropdownBox, {
          active: opened
        }, item.submenu.map(function (subItem) {
          return /*#__PURE__*/_react.default.createElement("li", {
            key: "submenu-" + subItem
          }, /*#__PURE__*/_react.default.createElement(_atoms.NavigationLink, {
            sublink: "true",
            title: _reactIntlUniversal.default.get("NAVEGACAO.SUBMENU." + (0, _utils.intlParse)(subItem)),
            as: _atoms.GlobalLink,
            to: label === subItem ? "/" + label : "/" + label + "/" + subItem,
            globalUrl: globalUrl
          }, _reactIntlUniversal.default.get("NAVEGACAO.SUBMENU." + (0, _utils.intlParse)(subItem))));
        }))) : /*#__PURE__*/_react.default.createElement(_atoms.NavigationLink, {
          title: _reactIntlUniversal.default.get("NAVEGACAO." + (0, _utils.intlParse)(label)),
          as: _atoms.GlobalLink,
          to: label === 'relatorios' ? (0, _utils.moveToParams)(label) : "/" + label,
          globalUrl: globalUrl
        }, _reactIntlUniversal.default.get("NAVEGACAO." + (0, _utils.intlParse)(label))));
      })));
    };

    return Navigation;
  }(_react.Component);

  Navigation.defaultProps = {
    hideHomeLink: false
  };

  var _default = (0, _reactOnclickoutside.default)(Navigation);

  _exports.default = _default;
});